import React from 'react';
import Table from 'material-ui/Table';
import { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table';
import Paper from 'material-ui/Paper';

export default function RegisteredUsers({ values }) {
  return (
    <Paper>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Email</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {values.map(value => (
            <TableRow>
              <TableCell>{value.full_name}</TableCell>
              <TableCell>{value.email}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  )
}



/** WEBPACK FOOTER **
 ** ./src/components/Admin/Webinar/RegisteredUsers.jsx
 **/